module.exports = __webpack_public_path__ + "img/inscricoes-abertasMobile.svg";